import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContexte';
import { useLanguage } from '../../contexts/LanguageContext';
import LanguageSwitch from '../layout/LanguageSwitch';
import Logo from '../ui/Logo';
import Icon from '../ui/Icon';
import './LoginPage.css';

const CLIENT_ID = process.env.REACT_APP_DISCORD_CLIENT_ID;
const REDIRECT_URI = process.env.REACT_APP_DISCORD_REDIRECT_URI;

const LoginPage = () => {
    const location = useLocation();
    const { token, setRedirectTarget } = useAuth();
    const { t } = useLanguage();

    // Serveur de destination après connexion (?redirect=<serverId>)
    useEffect(() => {
        const serverId = new URLSearchParams(location.search).get('redirect');
        if (serverId) setRedirectTarget(serverId);
    }, [location, setRedirectTarget]);

    // Déjà connecté (token encore valide) : pas besoin de repasser par Discord
    if (token) {
        const serverId = new URLSearchParams(location.search).get('redirect');
        return <Navigate to={serverId ? `/server/${serverId}` : '/welcome'} replace />;
    }

    const handleLogin = () => {
        const scope = 'identify email guilds';
        window.location.href = `https://discord.com/oauth2/authorize?client_id=${CLIENT_ID}&response_type=code&redirect_uri=${encodeURIComponent(REDIRECT_URI)}&scope=${encodeURIComponent(scope)}`;
    };

    return (
        <main className="c2-page login-page">
            <div className="login-page__lang">
                <LanguageSwitch variant="c2" />
            </div>

            <section className="c2-card login-card c2-fade-up">
                <Logo size={180} />
                <div className="login-card__titles">
                    <h1 className="login-card__title">LadderPVP</h1>
                </div>
                <button type="button" className="c2-btn c2-btn--primary c2-btn--lg c2-btn--block" onClick={handleLogin}>
                    <Icon name="login" size={20} />
                    {t('login.button')}
                </button>
            </section>
        </main>
    );
};

export default LoginPage;
